<template>
    <article class="article_card">
        <img class="article_card__image" v-if="image" :src="image">
        <h2 class="article_card__title">{{ article.title }}</h2>
        <div class="article_card__intro" v-html="intro"></div>
        <router-link
          class="readmore"
          :to="{
            name: routename,
            params:{
              id: article.id
            }
          }">Weiterlesen</router-link>
    </article>
</template>

<script type="text/babel">
module.exports = {
  data() {
    return {
      thumbSize: 500,
    };
  },
  props: {
    article: {
      required: true,
    },
    introLength: {
      default: 200,
    },
  },
  computed: {
    intro() {
      if (this.article.description) {
        return this.article.description.substr(0, this.introLength);
      }
      return this.article.content.substr(0, this.introLength);
    },
    image() {
      return this.$helpers.getThumbnail(this.article.image);
    },
    routename() {
      return `${this.$route.name}.details`;
    },
  },
};
</script>

<style lang="scss">
    .article_card {
        padding: 1em;
        border-radius: 4px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.22);
        margin: 1em;
        overflow: hidden;
        display: grid;
        grid-template-areas: "title image" "desc image" "readmore image";
        grid-auto-rows: min-content 1fr;
        grid-auto-columns: 1fr minmax(350px, min-content);
        grid-column-gap: 2em;
        .readmore {
            grid-area: readmore;
            /*border: solid 2px;*/
            border-radius: 0 12px 0 0;
            text-decoration: none;
            padding: .75em;
            display: table;
            margin:  1em auto -1em -1em;
            font-weight: 500;
            text-align: center;
            background: linear-gradient(to right, var(--gradient-color-1), var(--gradient-color-2));
            color: #fff;
        }
        &__image {
            width: calc(100% + 1em);
            grid-area: image;
            margin: -1em;
            margin-left: 0;
            align-self: stretch;
            object-fit: cover;
        }
        &__title {
            grid-area: title;
            font-size: 2.25em;
            margin: .25em 0 .5em 0;
            font-weight: 300;
        }
        &__intro {
            grid-area: desc;
            line-height: 175%;
        }
    }
</style>
